module.exports = ".no-overflow {\n  overflow: hidden;\n  text-overflow: break-word; }\n\n.btn-wrap {\n  white-space: normal; }\n\n:host ::ng-deep span.select2-container {\n  width: 100% !important; }\n\n.vertical-timeline-content .btn {\n  float: left; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/devices/editDevice.component.scss
// module id = ./src/app/views/devices/editDevice.component.scss
// module chunks = main